export default __webpack_public_path__ + "static/media/books-52.d5c653fb.jpg";